import { html, render } from 'lit-html';
import CtvDialogBase from './dialog-base'
import "./dialog-popup.scss";


export default class CtvDialogPopup extends CtvDialogBase {

	static get DomTag() { return  'ctv-dialog-popup'; }

	GetTranslations() {
		return {
			"Ok": {
				"it": "Ok",
				"en": "Ok"
			},
			"Si": {
				"it": "Si",
				"en": "Yes"
			},
			"No": {
				"it": "No",
				"en": "No"
			},						
			"Annulla": {
				"it": "Annulla",
				"en": "Cancel"
			},						

		}
	}

	static get properties() {
		return {
			
			body: {type: Object},
			title: {type: Object},

		};
	}

	constructor() {
		super();

		this.title=null;
		this.body=null;

		this.OkBtnText = null;
		this.NoBtnText = null;
		this.CancelBtnText = null;
	}

	RenderHeader() {
		return html`${this.ToHtml(this.title)}`;
	}

	RenderBody() {
		return html`${this.ToHtml(this.body)}`;
	}

	RenderFooter() {

		return html`
			${this.CancelBtnText!=null?html`
				<a href="#" @click="${this._OnCancelClicked}" class="cta-cancel">
					${this.ToHtml(this.CancelBtnText)}
				</a>	
			`:``}
			${this.NoBtnText!=null?html`
				<button @click="${this._OnNoClicked}" class="cta-no">
					${this.ToHtml(this.NoBtnText)}
				</button>	
			`:``}
			${this.OkBtnText!=null?html`
				<button @click="${this._OnOkClicked}" class="cta-ok">
					${this.ToHtml(this.OkBtnText)}
				</button>	
			`:``}		
		`;
	}

	_OnOkClicked(evt) {		
		if (this.NoBtnText == null)
			this.ReturnModalResult(this.MODAL_RESULT.OK);
		else
			this.ReturnModalResult(this.MODAL_RESULT.YES);
	}

	_OnCancelClicked(evt) {
		evt.preventDefault()
		this.ReturnModalResult(this.MODAL_RESULT.CANCEL);
	}

	_OnNoClicked(evt) {
		this.ReturnModalResult(this.MODAL_RESULT.NO);
	}

	static ShowMessageBox(Title, Message, OkBtnText) {

		let dlg = new CtvDialogPopup()
		dlg.title=Title;
		dlg.body=Message;
		dlg.OkBtnText = OkBtnText || dlg.Ln("Ok");

		return CtvDialogBase.Show(dlg);
	}

	static ShowYesNoBox(Title, Message, YesBtnText, NoBtnText) {

		let dlg = new CtvDialogPopup()
		dlg.title=Title;
		dlg.body=Message;

		dlg.OkBtnText = YesBtnText || dlg.Ln("Si");
		dlg.NoBtnText = NoBtnText || dlg.Ln("No");

		return CtvDialogBase.Show(dlg);
	}	

	static ShowYesNoCancelBox(Title, Message, YesBtnText, NoBtnText, CancelBtnText) {

		let dlg = new CtvDialogPopup()
		dlg.title=Title;
		dlg.body=Message;

		dlg.OkBtnText = YesBtnText || dlg.Ln("Si");
		dlg.NoBtnText = NoBtnText || dlg.Ln("No");
		dlg.CancelBtnText = CancelBtnText || dlg.Ln("Annulla");

		return CtvDialogBase.Show(dlg);
	}	

}
CtvDialogPopup.RegisterElement();

